
import { Component, Vue } from 'vue-property-decorator';
import PageContentLayoutContainer from '@/components/PageTemplate/PageContentLayoutContainer.vue';
import { AnimationType } from '@/types';

@Component({
  components: { PageContentLayoutContainer },
})
export default class EnergyWaterNeed extends Vue {
  animation: AnimationType = {
    name: 'energy-water-needs',
    lottie: true,
  };
}
